<!-- 业务商品调价操作 -->
<template>
<div>
    <div v-if="isLoaded">
        <div class="demo-drawer__content data_action_form">
            <el-tabs type="border-card" v-model="showTabs" class="el-tabs--border-card_new">
                <el-tab-pane label="调价信息表单">
                    <div class="table_content_box">
                        <el-form size="mini" class="baseForm" label-width="150px" :model="sendDataInfo" ref="sendDataInfo" :show-message="false">
                            <el-row>
                                <el-form-item label="最低售价" :rules="[{required: true,trigger: ['blur', 'change']}]" prop="lowestPrice">
                                    <el-input type="number" v-model.trim="sendDataInfo.lowestPrice" @blur="blur('lowestPrice')" :maxlength="$store.state.inputLength"></el-input>
                                </el-form-item>
                                 <el-form-item label="建议售价" :rules="[{required: true,trigger: ['blur', 'change']}]" prop="suggestedPrice">
                                    <el-input type="number" v-model.trim="sendDataInfo.suggestedPrice" @blur="blur('suggestedPrice')" :maxlength="$store.state.inputLength"></el-input>
                                </el-form-item>
                                <el-form-item label="最后进价" prop="lastPirce">
                                    <el-input type="number" disabled v-model.trim="sendDataInfo.lastPirce"></el-input>
                                </el-form-item>
                                <el-form-item label="采购价" prop="purchasePrice">
                                    <el-input type="number"  v-model.trim="sendDataInfo.purchasePrice"  @blur="blur('purchasePrice')"></el-input>
                                </el-form-item>
                            </el-row>
                        </el-form>
                      
                    </div>
                </el-tab-pane>
                <el-tab-pane label="价格策略表单">
                  <!-- 价格策略 -->
                  <el-table size='mini' border :data="midPriceData">
                            <el-table-column v-for="(formOneValue,formOneKey) in formListValue.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                                <template slot-scope="scope" v-if="formOneValue.isReserved == 0">
                                    <el-switch v-if="formOneValue.entityField == 'priceType'" v-model="midPriceData[scope.$index].priceType" active-text="按折扣" inactive-text="按价格" @change="refreshTable(scope.$index)"></el-switch>
                                    <template v-else-if="formOneValue.entityField == 'levleDiscount'">
                                        <input :class="['oldInput',!midPriceData[scope.$index].priceType?'oldDisabled':'']" :disabled="!midPriceData[scope.$index].priceType" type="number" min="0" max="100" v-model="midPriceData[scope.$index].levleDiscount" oninput="value=value.replace(/[^0-9.]/g,'')" /> %
                                    </template>
                                    <template v-else-if="formOneValue.entityField == 'levlePrice'">
                                        <input :class="['oldInput',midPriceData[scope.$index].priceType?'oldDisabled':'']" :disabled="midPriceData[scope.$index].priceType" type="number" min="0" v-model.number="midPriceData[scope.$index].levlePrice" />
                                    </template>
                                    <div v-else-if="formOneValue.entityField == 'levleName'">
                                        <span v-for="(item,index) in priceResData" :key="index">
                                            <span v-if="item.levleId == scope.row.levleId">
                                                {{item.levleName}}
                                            </span>
                                        </span>
                                    </div>
                                    <div v-else>
                                        {{scope.row[formOneValue.entityField]}}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                </el-tab-pane>
            </el-tabs>
            <div class="foot">
                <div>
                    <el-button v-if="dataActionBox.actionType!=2" type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')">确定</el-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    name: "businessGoodsPrice",
    props: ['bgPriceActionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            // dialogisible: false,
            token: {
                token: sessionStorage.getItem("token")
            },
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "编辑调价信息",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                bgfId: '', //	业务商品财务相关信息ID
                lowestPrice: 0, //	最低售价
                suggestedPrice: 0, //	建议售价
                lastPirce:0,//最后进价
                purchasePrice:0,//采购价
                dempBusgoodpriceList:[], 
            },
            showTabs: "",
            formDataList: '',
            dictionariesData: {},
            midPriceData: [],
            priceResData: [],
            isLoaded: false,
            formListValue: [],  //动态表单
            bgmId:''

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      blur(index){
        this.sendDataInfo[index]=this.$common.getDecimalInfo(2,this.sendDataInfo[index])
      },
        taxChange(data) {
            console.log('data', data);
            for (let i = 0; i < this.dictionariesData.swflmc.length; i++) {
                const item = this.dictionariesData.swflmc[i]
                if (item.diName == data) {
                    this.sendDataInfo.busgoodfinance.taxnumber = item.diCode
                    break;
                }
            }
        },
        //刷新价格表
        refreshTable(e) {
            console.log(this.midPriceData[e].priceType)
            // this.midPriceData[e].priceType =!this.midPriceData[e].priceType
            
            this.midPriceData.splice(1, 0);
        },
        //保存
        async sendDataAction(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    return false;
                }
            })
        },
        async sub() {
            this.sendDataInfo.dempBusgoodpriceList = [];
            for (let i = 0; i < this.midPriceData.length; i++) {
                const item = this.midPriceData[i];
                this.sendDataInfo.dempBusgoodpriceList[i] = {};
                console.log(this.midPriceData)
                if (item.priceType == false) {
                    //价格
                    let num = parseFloat(item.levlePrice);
                    console.log(item)
                    if (num < 0) {
                        this.$message({
                          message: "请填入合理价格",
                          type: "error",
                        });
                        return false;
                    } else {
                        for (const key in item) {
                            if (Object.hasOwnProperty.call(item, key)) {
                                if (key == "priceType")
                                    this.sendDataInfo.dempBusgoodpriceList[i].priceType = 0;
                                if (key == "levleDiscount")
                                    this.sendDataInfo.dempBusgoodpriceList[i].levleDiscount = 0;
                                if (key == "levlePrice")
                                    this.sendDataInfo.dempBusgoodpriceList[i].levlePrice = this.$common.getDecimalInfo(2,num);
                                if (key == "levleId")
                                    this.sendDataInfo.dempBusgoodpriceList[i].levleId = item[key];
                                if (key == "bgcId")
                                    this.sendDataInfo.dempBusgoodpriceList[i].bgcId = item[key];
                                if (key == "bgmId")
                                    this.sendDataInfo.dempBusgoodpriceList[i].bgmId = item[key];
                            }
                        }
                    }
                } else {
                    //折扣
                    let num = parseFloat(item.levleDiscount);
                    if (num > 100 || num < 0) {
                        this.$message({
                            message: "请填入合理折扣",
                            type: "error",
                        });
                        return false;
                    } else {
                        for (const key in item) {
                            if (key == "priceType") this.sendDataInfo.dempBusgoodpriceList[i].priceType = 1;
                            if (key == "levleDiscount") this.sendDataInfo.dempBusgoodpriceList[i].levleDiscount = num;
                            if (key == "levlePrice") this.sendDataInfo.dempBusgoodpriceList[i].levlePrice = 0;
                            if (key == "levleId") this.sendDataInfo.dempBusgoodpriceList[i].levleId = item[key];
                            if (key == "bgcId") this.sendDataInfo.dempBusgoodpriceList[i].bgcId = item[key];
                            if (key == "bgmId") this.sendDataInfo.dempBusgoodpriceList[i].bgmId = item[key];
                        }
                    }
                }
            }
            let newSendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
            // console.log('send',newSendDataInfo)
            newSendDataInfo.bgmId=this.bgmId
            delete newSendDataInfo.bgfId
            var responseData
            responseData = await this.$http.cusinessGoodsTunePrice(newSendDataInfo);
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit('priceDrawerCancel',true)
                this.$refs["sendDataInfo"].resetFields();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //取消
        initActionBox(formName) {
            this.$confirm('确定取消编辑吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.dataActionBox.actionType = 0
                this.$emit('priceDrawerCancel')
                this.init()
                this.$refs[formName].resetFields()
            }).catch(() => {});
        },
        // 初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'dempBusgoodpriceList') {
                    this.sendDataInfo.dempBusgoodpriceList = [];
                }else{
                    this.sendDataInfo[key] = "";
                }
            }
            this.sendDataInfo.lowestPrice = 0
            this.sendDataInfo.lowestPrice = 0
            this.sendDataInfo.lastPirce = 0
        },
        //获取列表
        openBox(cate, formData, oldData) {
            console.log(formData,111111111);
            console.log('===', oldData)
            this.dataActionBox.actionType = cate
            this.formListValue = formData
            this.init();
            this.getPriceList().then(() => {
                if (this.dataActionBox.actionType == 2) {
                    this.dataActionBox.boxTitle = '查看信息'
                } else {
                    this.dataActionBox.openMode = "rtl";
                }
                for (const key in this.sendDataInfo) {
                    if(key == 'dempBusgoodpriceList'){
                        if(oldData.dempBusgoodpriceList && oldData.dempBusgoodpriceList.length > 0){
                            oldData.dempBusgoodpriceList.forEach((v, i) => {
                                if (!this.midPriceData[i]) this.midPriceData[i] = {}
                                for (const key in v) {
                                    const child = v[key];
                                    if (key == "priceType") child == 0 ? this.midPriceData[i].priceType = false : this.midPriceData[i].priceType = true;
                                    if (key == "levleDiscount") this.midPriceData[i].levleDiscount = v[key];
                                    if (key == "levlePrice") this.midPriceData[i].levlePrice = v[key];
                                    if (key == "levleId") this.midPriceData[i].levleId = v[key];
                                    if (key == "bgcId") this.midPriceData[i].bgcId = v[key];
                                    if (key == "bgmId") this.midPriceData[i].bgmId = oldData[key];
                                }
                            });
                            this.midPriceData.splice(1, 0);
                        }else{
                            this.midPriceData = []
                            this.priceResData.forEach((v) => {
                                this.midPriceData.push({
                                    levleId: v.levleId,
                                    levleDiscount: 0,
                                    levlePrice: 0,
                                    priceType: false,
                                })
                            })
                        }
                    }else{
                        this.sendDataInfo[key] = oldData[key]
                    }
                }
                this.dataActionBox.showStatus = true;
                console.log('this.sendDataInfo',this.sendDataInfo)
            })
        },
        //获取价格策略(新增)
        async getPriceList() {
            var responseData = await this.$http.getPriceStrategyGroup(this.token);
            if (responseData.status == 200) {
                this.priceResData = responseData.result;
            } else {
                this.$message({
                    message: "获取价格策略失败",
                    type: "error",
                });
                return false;
            }
        },
        
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [14, 15, 10, 9, 6, 25, 7, 11, 13, 8, 5, 30],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            var params = this.bgPriceActionData
            this.openBox(params.cate, params.formData, JSON.parse(JSON.stringify(params.oldData)))
            this.bgmId=params.oldData.bgmId
            this.isLoaded = true
        })
        this.getPartDictionariesData();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 450px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.oldInput {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 90%;
}

.oldDisabled {
    background-color: #f5f7fa;
}
</style>
